import { useEffect, useState } from 'react';

/** Ogni quanto si aggiorna il tempo: 30s, come il polling delle richieste in admin. */
const REFRESH_MS = 30_000;

/**
 * Timestamp corrente, aggiornato periodicamente.
 *
 * Serve ai componenti che devono accorgersi del passaggio del tempo (es. un
 * evento che inizia) senza ricaricare la pagina. L'intervallo si ferma allo
 * smontaggio del componente.
 */
export function useNow(refreshMs = REFRESH_MS): number {
    const [now, setNow] = useState(() => Date.now());

    useEffect(() => {
        const interval = setInterval(() => setNow(Date.now()), refreshMs);
        return () => clearInterval(interval);
    }, [refreshMs]);

    return now;
}
